import CellGroup from '../cell/src/cell-group';

export default CellGroup;



// WEBPACK FOOTER //
// ./packages/cell-group/index.js